import React from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";

function PresidentSpeech() {
  return (
    <div>
      <div className="SoleraBody440">
        <div className="container LandingContOthers ">
          <div className="LandingWrapper">
            <div className="LandingContainer6007">
              <div className="LandingCoverUp">
               
                <div className="SoleraIntro-Speech">
                  " We are delighted that you've found your way to this page,
                  and we wholeheartedly encourage you to consider joining our
                  membership. In the upcoming year, we have planned four
                  exciting social events that will provide excellent
                  opportunities for you to establish new connections and
                  rekindle old ones. Furthermore, we have scheduled three
                  informative seminars led by industry experts who are proud
                  alumni of Akoka. Who knows? The next seminar could be an
                  opportunity for you to share your expertise and insights as a
                  leader in your field. "
                </div>
                <div>
                  <div className="Presido mt-3">Afolabi Phillips</div>
                  <div className="Position-Exco mb-3">President</div>
                  <div className="Representing">UNILAG ALUMNI UK</div>
                </div>
              </div>
            </div>
            <div className="LandImg02">
              <img
                src="/assets/solera/6001.png"
                alt=""
                className="SoleraLandingImg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PresidentSpeech;
